import { SLIM } from "./footer-consts";

export default {
  footer_type: SLIM
};
